import { createContext, useContext } from 'react';

const RowContext = createContext();
export const MentionContextProvider = RowContext.Provider;
export const MentionContextConsumer = RowContext.Consumer;
export const useMentionContext = () => useContext(RowContext);
